/**
 * Koshirae Configurator — Tokyo Nihonto
 * Dynamic pricing, conditional sections, image grids, Shopify Cart AJAX
 */
(function () {
  'use strict';

  /* ─────────────────────────────────────────────
     CONSTANTS
  ───────────────────────────────────────────── */
  var BASE_PRICE = 5000;

  // Variant ID — set by Liquid via data attribute or fallback
  var VARIANT_ID = 56463563718980;

  var CDN = 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/';

  /* ─────────────────────────────────────────────
     COLOR DATA
  ───────────────────────────────────────────── */
  var TSUKAITO_COLORS = {
    cotton: [
      { name: 'Black',         hex: '#1a1a1a' },
      { name: 'Navy',          hex: '#1b2a4a' },
      { name: 'Iron Navy',     hex: '#2b3545' },
      { name: 'Purple',        hex: '#5a3570' },
      { name: 'Azuki',         hex: '#8b3a3a' },
      { name: 'Brown',         hex: '#8b5e3c' },
      { name: 'Uguisu',        hex: '#6b7c3c' },
      { name: 'Golden Yellow', hex: '#c9a227' },
      { name: 'Red',           hex: '#c0392b' },
      { name: 'White',         hex: '#f0ede8', light: true }
    ],
    silk: [
      { name: 'Black',         hex: '#1a1a1a' },
      { name: 'Navy',          hex: '#1b2a4a' },
      { name: 'Iron Navy',     hex: '#2b3545' },
      { name: 'Purple',        hex: '#5a3570' },
      { name: 'Golden Yellow', hex: '#c9a227' },
      { name: 'Dark Brown',    hex: '#4a2c1a' },
      { name: 'Uguisu',        hex: '#6b7c3c' },
      { name: 'Vermillion',    hex: '#d4490a' },
      { name: 'Red',           hex: '#c0392b' },
      { name: 'White',         hex: '#f0ede8', light: true }
    ],
    'cow-leather': [
      { name: 'Black',         hex: '#1a1a1a' },
      { name: 'Dark Brown',    hex: '#2c1a0e' },
      { name: 'Brown',         hex: '#8b5e3c' },
      { name: 'Reddish Brown', hex: '#7a3020' },
      { name: 'Kyara',         hex: '#6b4c28' },
      { name: 'Tetsu Nando',   hex: '#2b3545' },
      { name: 'Uguisu',        hex: '#6b7c3c' }
    ],
    'pig-leather': [
      { name: 'Ink Black',       hex: '#1a1a1a' },
      { name: 'Persimmon Brown', hex: '#9b4510' },
      { name: 'Walnut Brown',    hex: '#5c3a22' }
    ],
    'deer-leather': [
      { name: 'Ink Black',       hex: '#1a1a1a' },
      { name: 'Persimmon Brown', hex: '#9b4510' },
      { name: 'Walnut Brown',    hex: '#5c3a22' }
    ]
  };

  var SAGEO_COLORS = {
    cotton: [
      { name: 'Black',         hex: '#1a1a1a' },
      { name: 'Navy',          hex: '#1b2a4a' },
      { name: 'Purple',        hex: '#5a3570' },
      { name: 'Brown',         hex: '#8b5e3c' },
      { name: 'Red',           hex: '#c0392b' },
      { name: 'White',         hex: '#f0ede8', light: true },
      { name: 'Golden Yellow', hex: '#c9a227' },
      { name: 'Uguisu',        hex: '#6b7c3c' }
    ],
    silk: [
      { name: 'Black',      hex: '#1a1a1a' },
      { name: 'Navy',       hex: '#1b2a4a' },
      { name: 'Purple',     hex: '#5a3570' },
      { name: 'Dark Brown', hex: '#4a2c1a' },
      { name: 'Crimson',    hex: '#9b1a1a' },
      { name: 'White',      hex: '#f0ede8', light: true },
      { name: 'Gold',       hex: '#c9a227' },
      { name: 'Uguisu',     hex: '#6b7c3c' }
    ]
  };

  /* ─────────────────────────────────────────────
     IMAGE GRID DATA
  ───────────────────────────────────────────── */

  // TSUBA — page 1 (T-7 to T-96) → koshirae-tsuba-0000 to 0049
  // TSUBA — page 2 (T-97 to T-167) → koshirae-tsuba2-0000 to 0055
  var TSUBA_DESIGNS = [
    { code: 'T-7', name: 'Maple', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-000_dc07f2ae-616a-4532-9969-8031e14914e9.jpg' },
    { code: 'T-8', name: 'Scaled Dragon', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-001_344577de-f25f-406a-b0a8-b2f36536d839.jpg' },
    { code: 'T-9', name: 'Cloud Dragon', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-002_4efa3765-3ce3-4881-bed8-44023378fadd.jpg' },
    { code: 'T-10', name: 'Square Plum', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-003_d4a6c26b-85d1-49ba-8d34-88152ff612a8.jpg' },
    { code: 'T-11', name: 'Ginkgo', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-004_3eb4cfe2-9310-4aac-83ba-6d8dfa94c337.jpg' },
    { code: 'T-13', name: 'Sakura & Horse', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-005_5dacb906-641b-4e8a-8f39-13fb92fe0ea7.jpg' },
    { code: 'T-14', name: 'Fan', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-006_87d1aa0d-1ef4-45b0-a8bc-ebd14e9af97c.jpg' },
    { code: 'T-15', name: 'Bamboo & Tiger', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-007_9aae82ef-30cc-4344-90ce-343db80b1668.jpg' },
    { code: 'T-16', name: 'Wave & Koi', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-008_5ccaff00-fa8f-4d8d-938c-4b712e3a71b7.jpg' },
    { code: 'T-17', name: 'Harness & Baton', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-009_e3c7c333-77e8-4c06-a412-b92a6baea337.jpg' },
    { code: 'T-19', name: 'Bird', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-010.jpg' },
    { code: 'T-20', name: 'Gourd', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-011.jpg' },
    { code: 'T-21', name: 'Dragon Fly', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-012.jpg' },
    { code: 'T-24', name: 'Wicker', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-013.jpg' },
    { code: 'T-25', name: 'Arrowhead', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-014.jpg' },
    { code: 'T-27', name: 'Bamboo Leaves', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-015.jpg' },
    { code: 'T-28', name: 'Wave & Plover', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-016.jpg' },
    { code: 'T-172', name: 'Ono Daimoku', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-017.jpg' },
    { code: 'T-30', name: 'Cormorant & Basket', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-018.jpg' },
    { code: 'T-31', name: 'Kinai', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-019.jpg' },
    { code: 'T-32', name: 'Cloud', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-020.jpg' },
    { code: 'T-34', name: 'Catfish', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-021.jpg' },
    { code: 'T-35', name: 'Square Dragon', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-022.jpg' },
    { code: 'T-36', name: 'Yagyu', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-023.jpg' },
    { code: 'T-37', name: 'Small Plum', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-024.png' },
    { code: 'T-39', name: 'Kiku Karakusa', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-025.jpg' },
    { code: 'T-41', name: 'Sukashi Dragon', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-026.jpg' },
    { code: 'T-44', name: 'Mikazuki Musashi', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-027.jpg' },
    { code: 'T-173', name: 'Masayoshi Kiku', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-028.jpg' },
    { code: 'T-46', name: 'Sanscrit', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-029.jpg' },
    { code: 'T-47', name: 'Kanayama', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-030.png' },
    { code: 'T-49', name: 'Paulownia', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-031.jpg' },
    { code: 'T-51', name: 'Flower Raft', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-032.jpg' },
    { code: 'T-58', name: 'Kyo Kiku Sukashi', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-033.jpg' },
    { code: 'T-60', name: 'Hijikata', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-034.jpg' },
    { code: 'T-61', name: 'Yagyu Kasa', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-035.jpg' },
    { code: 'T-63', name: 'Butterfly Sukashi', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-036.jpg' },
    { code: 'T-65', name: 'Sakura Kiku', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-037.jpg' },
    { code: 'T-66', name: 'Kinai Dragon', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-038.jpg' },
    { code: 'T-76', name: 'Guribori Sukashi', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-039.png' },
    { code: 'T-78', name: 'Owari', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-040.png' },
    { code: 'T-79', name: 'Deer & Maple', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-041.jpg' },
    { code: 'T-80', name: 'Choshu Dragon', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-042.jpg' },
    { code: 'T-82', name: 'Yagyu Bamboo', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-043.jpg' },
    { code: 'T-84', name: 'Dokko Sword', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-044.jpg' },
    { code: 'T-90', name: 'Old Coins', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-045.jpg' },
    { code: 'T-91', name: 'Brush', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-046.jpg' },
    { code: 'T-93', name: 'Lion', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-047.jpg' },
    { code: 'T-95', name: 'Musashi', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-048.jpg' },
    { code: 'T-96', name: 'Rankanzu', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba-049.jpg' },
    { code: 'T-97', name: 'Echizen Dragon', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-000.jpg' },
    { code: 'T-98', name: 'Torii & Man', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-001.jpg' },
    { code: 'T-99', name: 'Katsujin Ken', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-002.jpg' },
    { code: 'T-101', name: 'Seigaiha', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-003.jpg' },
    { code: 'T-102', name: 'Cloud Dragon', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-004.jpg' },
    { code: 'T-103', name: 'Pine', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-005.jpg' },
    { code: 'T-105', name: 'Bamboo', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-006.jpg' },
    { code: 'T-106', name: 'Mantis', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-007.png' },
    { code: 'T-107', name: 'Tadatoki Kiku', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-008.png' },
    { code: 'T-108', name: 'Warriors', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-009.jpg' },
    { code: 'T-109', name: 'Spiderweb', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-010.jpg' },
    { code: 'T-110', name: 'Carp Wave', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-011.png' },
    { code: 'T-111', name: 'Satsuma Tiger', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-012.jpg' },
    { code: 'T-112', name: 'Butterflies', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-013.jpg' },
    { code: 'T-113', name: 'Rain Dragon', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-014.jpg' },
    { code: 'T-114', name: 'Daikoku', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-015.jpg' },
    { code: 'T-116', name: 'Victory Dragonfly', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-016.jpg' },
    { code: 'T-118', name: 'Awa', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-017.jpg' },
    { code: 'T-119', name: 'Tiger Sukashi', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-018.jpg' },
    { code: 'T-120', name: 'Chinese Lion', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-019.jpg' },
    { code: 'T-121', name: 'Nine Rings', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-020.jpg' },
    { code: 'T-122', name: 'Plum', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-021.jpg' },
    { code: 'T-124', name: 'Dancing Dragonflies', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-022.png' },
    { code: 'T-126', name: 'Plovers', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-023.jpg' },
    { code: 'T-127', name: 'Old Coins', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-024.jpg' },
    { code: 'T-128', name: 'Egret', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-025.jpg' },
    { code: 'T-129', name: 'Sansui', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-026.jpg' },
    { code: 'T-130', name: 'Vines', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-027.jpg' },
    { code: 'T-132', name: 'Pine & Crane', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-028.jpg' },
    { code: 'T-133', name: 'Plum & Uguisu', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-029.jpg' },
    { code: 'T-135', name: 'Peony', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-030.jpg' },
    { code: 'T-136', name: 'Falcon', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-031.jpg' },
    { code: 'T-137', name: 'Ai', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-032.jpg' },
    { code: 'T-138', name: 'Crab', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-033.jpg' },
    { code: 'T-139', name: 'Higo Tiger', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-034.png' },
    { code: 'T-140', name: 'Phoenix', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-035.jpg' },
    { code: 'T-142', name: 'Kiku', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-036.jpg' },
    { code: 'T-144', name: 'Hanjiro', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-037.jpg' },
    { code: 'T-145', name: 'Sayagata', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-038.png' },
    { code: 'T-146', name: 'Rabbit', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-039.jpg' },
    { code: 'T-147', name: 'Lions & Peony', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-040.jpg' },
    { code: 'T-148', name: 'Peony Blossoms', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-041.jpg' },
    { code: 'T-153', name: 'Watanabe', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-042.jpg' },
    { code: 'T-154', name: 'Old Bones', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-043.jpg' },
    { code: 'T-155', name: 'Mt Horai', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-044.jpg' },
    { code: 'T-156', name: 'Dragon', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-045.jpg' },
    { code: 'T-158', name: 'Broad Wave', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-046.jpg' },
    { code: 'T-159', name: 'Umetada Kiku', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-047.jpg' },
    { code: 'T-160', name: 'Mito Dragon', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-048.jpg' },
    { code: 'T-161', name: 'Sukashi', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-049.jpg' },
    { code: 'T-162', name: 'Seiho Pine', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-050.jpg' },
    { code: 'T-163', name: 'Satsuma Maple', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-051.jpg' },
    { code: 'T-164', name: 'Bamboo & Crab', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-052.png' },
    { code: 'T-165', name: 'Dewy Bamboo', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-053.jpg' },
    { code: 'T-166', name: 'Kasen Butterfly', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-054.jpg' },
    { code: 'T-167', name: 'Sekiwa', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-tsuba2-055.jpg' }
  ];

  // FUCHI-KASHIRA gallery — all images, browse & type your code
  var FUCHI_DESIGNS = [
    { code: 'KS-1', name: 'Rope Texture', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-001.jpg' },
    { code: 'KS-2', name: 'Vines', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-002.jpg' },
    { code: 'KS-4', name: 'Dragon', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-003.jpg' },
    { code: 'KS-5', name: 'Arabesque Scroll (Higo Karakusa)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-010.jpg' },
    { code: 'KS-7', name: 'Wave Grass (Nami Kusa)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-005.jpg' },
    { code: 'KS-8', name: 'Ocean Wave', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-006.jpg' },
    { code: 'KS-9', name: 'Bird', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-007.jpg' },
    { code: 'KS-11', name: 'Dragonfly', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-008.jpg' },
    { code: 'KS-12', name: 'Stone Texture (Higo)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-009.jpg' },
    { code: 'KS-13', name: 'Flat Wave (Hiranami Higo)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-019.jpg' },
    { code: 'KS-14', name: 'Wicker Weave (Ajiro)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-011.jpg' },
    { code: 'KS-15', name: 'Arrowhead', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-012.jpg' },
    { code: 'KS-16', name: 'Openwork (Kyo Sukashi)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-013.jpg' },
    { code: 'KS-17', name: 'Maple Leaf', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-085.jpg' },
    { code: 'KS-18', name: 'High Wave', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-014.jpg' },
    { code: 'KS-19', name: 'Sanskrit Symbols', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-015.jpg' },
    { code: 'KS-20', name: 'Openwork Clouds (Kobusho)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-016.jpg' },
    { code: 'KS-21', name: 'Peony Arabesque (Karakusa)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-017.jpg' },
    { code: 'KS-22', name: 'Flower Raft', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-018.jpg' },
    { code: 'KS-24', name: 'Musashi Style (Higo)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-052.jpg' },
    { code: 'KS-25', name: 'Mino Dragon', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-020.jpg' },
    { code: 'KS-26', name: 'Higo Wave (Openwork)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-021.jpg' },
    { code: 'KS-27', name: 'Plum Blossom', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-022.jpg' },
    { code: 'KS-28', name: 'Chrysanthemum Arabesque (Kiku Karakusa)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-023.jpg' },
    { code: 'KS-29', name: 'Paulownia Crest', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-024.jpg' },
    { code: 'KS-30', name: 'Rivet Pattern (Higo)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-025.jpg' },
    { code: 'KS-31', name: 'Auspicious Clouds (Zuiun)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-026.jpg' },
    { code: 'KS-32', name: 'Tensho Script', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-027.jpg' },
    { code: 'KS-33', name: 'Carved Lacquer (Guribori)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-028.jpg' },
    { code: 'KS-36', name: 'Yagyu School (Kasa)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-029.jpg' },
    { code: 'KS-37', name: 'Bamboo & Tiger', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-077.jpg' },
    { code: 'KS-38', name: 'Mori Clan (Tensho)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-078.jpg' },
    { code: 'KS-40', name: 'Double Arabesque (Karakusa)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-079.jpg' },
    { code: 'KS-41', name: 'Cloud', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-080.jpg' },
    { code: 'KS-42', name: 'Hijikata', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-081.jpg' },
    { code: 'KS-43', name: 'Plum Blossom (Higo)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-030.jpg' },
    { code: 'KS-44', name: 'Basket Weave (Higo)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-031.jpg' },
    { code: 'KS-46', name: 'Musashi Plain', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-042.jpg' },
    { code: 'KS-48', name: 'Floating Chrysanthemum (Kikusui)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-053.jpg' },
    { code: 'KS-49', name: 'Basket', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-064.jpg' },
    { code: 'KS-50', name: 'Butterflies', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-075.jpg' },
    { code: 'KS-51', name: 'Moon & Wave (Yagyu)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-086.jpg' },
    { code: 'KS-70', name: 'Tiger (Higo)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-096.jpg' },
    { code: 'KS-79', name: 'Life-Giving Sword (Katsujin Ken)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-097.jpg' },
    { code: 'KS-81', name: 'Kyoto Script (Kyo Tensho)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-098.jpg' },
    { code: 'KS-82', name: 'Spiderweb', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-032.jpg' },
    { code: 'KS-83', name: 'Satsuma Tiger', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-094.jpg' },
    { code: 'KS-84', name: 'Hollyhock Arabesque (Aoi Karakusa)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-034.jpg' },
    { code: 'KS-85', name: 'Chrysanthemum & Wave (Kikusui)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-035.jpg' },
    { code: 'KS-86', name: 'Kyoto Wicker (Kyo)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-036.jpg' },
    { code: 'KS-87', name: 'Flower Chrysanthemum (Hana Kiku)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-037.jpg' },
    { code: 'KS-88', name: 'Pine Tree', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-038.jpg' },
    { code: 'KS-89', name: 'Bamboo', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-039.jpg' },
    { code: 'KS-90', name: 'Ocean Wave Scales (Seigaiha)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-040.jpg' },
    { code: 'KS-91', name: 'Edo Script (Tensho)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-041.jpg' },
    { code: 'KS-92', name: 'Checkered Pattern (Ichimatsu)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-043.jpg' },
    { code: 'KS-93', name: 'Warrior Scene (Soten Musha)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-044.jpg' },
    { code: 'KS-94', name: 'Plain', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-057.jpg' },
    { code: 'KS-95', name: 'Dancing Chrysanthemum (Kiku)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-046.jpg' },
    { code: 'KS-96', name: 'Scrolling Vines (Kurin)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-047.jpg' },
    { code: 'KS-97', name: 'Rain Dragon', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-033.jpg' },
    { code: 'KS-98', name: 'Kyoto Plum (Kyo)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-049.jpg' },
    { code: 'KS-99', name: 'Lucky God (Daikoku)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-050.jpg' },
    { code: 'KS-100', name: 'Victory Dragonfly', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-051.jpg' },
    { code: 'KS-102', name: 'Sea Foam (Awa)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-073.jpg' },
    { code: 'KS-103', name: 'Pine & Torii Gate', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-082.jpg' },
    { code: 'KS-104', name: 'Koi Fish', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-083.jpg' },
    { code: 'KS-105', name: 'Shishi Lion', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-084.jpg' },
    { code: 'KS-106', name: 'Ivy Arabesque (Tsuta Karakusa)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-004.jpg' },
    { code: 'KS-107', name: 'Plum & Warbler', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-087.jpg' },
    { code: 'KS-108', name: 'Kyoto Stone (Kyo)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-074.jpg' },
    { code: 'KS-109', name: 'Plover Bird', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-089.jpg' },
    { code: 'KS-110', name: 'Dancing Lion Mask', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-090.jpg' },
    { code: 'KS-111', name: 'Dancing Dragonflies', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-091.jpg' },
    { code: 'KS-112', name: 'White Heron', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-099.jpg' },
    { code: 'KS-113', name: 'Old Coins', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-054.jpg' },
    { code: 'KS-114', name: 'Mountain Landscape (Sansui)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-055.jpg' },
    { code: 'KS-115', name: 'Wave & Cranes', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-056.jpg' },
    { code: 'KS-116', name: 'Ripple Wave (Ayanami)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-061.jpg' },
    { code: 'KS-117', name: 'Double Mountain Pass', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-068.jpg' },
    { code: 'KS-118', name: 'Peony (Higo)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-058.jpg' },
    { code: 'KS-119', name: 'Falcon in Pine', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-059.jpg' },
    { code: 'KS-120', name: 'Love Kanji (Ai / Kanetsugu)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-060.jpg' },
    { code: 'KS-121', name: 'Crab', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-048.jpg' },
    { code: 'KS-122', name: 'Tiger (Higo Longevity)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-062.jpg' },
    { code: 'KS-123', name: 'Phoenix', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-063.jpg' },
    { code: 'KS-124', name: 'Wave & Plover', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-065.jpg' },
    { code: 'KS-125', name: 'Peony', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-066.jpg' },
    { code: 'KS-126', name: 'Peony Blossom', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-093.jpg' },
    { code: 'KS-127', name: 'Beehive', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-067.jpg' },
    { code: 'KS-128', name: 'Higo Plain', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-045.jpg' },
    { code: 'KS-129', name: 'Skeleton (Old Bones)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-069.jpg' },
    { code: 'KS-130', name: 'Big Wave (Higo)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-070.jpg' },
    { code: 'KS-131', name: 'Kyoto Maple (Kyo)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-071.jpg' },
    { code: 'KS-132', name: 'Broad Cloud', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-072.jpg' },
    { code: 'KS-133', name: 'Lotus & Heron (Satsuma)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-092.jpg' },
    { code: 'KS-134', name: 'Higo Poetry Fan (Kasen)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-088.jpg' },
    { code: 'KS-135', name: 'Pine & Plum', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-076.jpg' },
    { code: 'KS-136', name: 'Chrysanthemum Cluster (Toyokiku)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-fk-095.jpg' }
  ];

  // MENUKI gallery — all images, browse & type your code
  var MENUKI_DESIGNS = [
    { code: 'M-002', name: 'Peas', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-000.jpg' },
    { code: 'M-006', name: 'Arrowhead', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-001.jpg' },
    { code: 'M-007', name: 'Dragon Twisted Sword', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-002.jpg' },
    { code: 'M-009', name: 'Triple Paulownia', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-003.jpg' },
    { code: 'M-010', name: 'Sparrow', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-004.jpg' },
    { code: 'M-011', name: 'Bee', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-010.jpg' },
    { code: 'M-012', name: 'Daikoku', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-011.jpg' },
    { code: 'M-013', name: 'Koi', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-012.jpg' },
    { code: 'M-014', name: 'Dokko Sword', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-013.jpg' },
    { code: 'M-016', name: 'Kiku', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-014.jpg' },
    { code: 'M-017', name: 'Kiku & Daffodils', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-020.jpg' },
    { code: 'M-018', name: 'Small Kiku', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-021.jpg' },
    { code: 'M-019', name: 'Holly', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-022.jpg' },
    { code: 'M-020', name: 'Single Kiku', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-023.jpg' },
    { code: 'M-022', name: 'Dragonfly', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-024.jpg' },
    { code: 'M-023', name: 'Phoenix', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-030.jpg' },
    { code: 'M-026', name: 'Kanji Characters', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-031.jpg' },
    { code: 'M-027', name: 'War Fan', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-032.jpg' },
    { code: 'M-028', name: 'Crane', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-033.jpg' },
    { code: 'M-029', name: 'Three Cranes', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-034.jpg' },
    { code: 'M-030', name: 'Sword & Armor', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-040.jpg' },
    { code: 'M-031', name: 'Gourd & Catfish', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-041.jpg' },
    { code: 'M-037', name: 'Autumn Flowers', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-042.jpg' },
    { code: 'M-038', name: 'Plum Blossom', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-043.jpg' },
    { code: 'M-039', name: 'Deer & Maple Leaves', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-044.jpg' },
    { code: 'M-040', name: 'Tiger & Bamboo', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-050.jpg' },
    { code: 'M-041', name: 'Wave & Koi', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-051.jpg' },
    { code: 'M-042', name: 'Pine', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-052.jpg' },
    { code: 'M-043', name: 'White Crane', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-053.jpg' },
    { code: 'M-044', name: 'Old Bones', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-054.jpg' },
    { code: 'M-045', name: 'Boat', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-060.jpg' },
    { code: 'M-046', name: 'Tree & Phoenix', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-061.jpg' },
    { code: 'M-048', name: 'Tiger', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-062.jpg' },
    { code: 'M-049', name: 'Rain Dragon', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-063.jpg' },
    { code: 'M-050', name: 'Catfish', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-064.jpg' },
    { code: 'M-051', name: 'Marishiten', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-070.jpg' },
    { code: 'M-053', name: 'Kirin', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-071.jpg' },
    { code: 'M-055', name: 'Japanese Pepper', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-072.jpg' },
    { code: 'M-056', name: 'Crane in Sunrise', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-073.jpg' },
    { code: 'M-057', name: 'Samurai', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-074.jpg' },
    { code: 'M-058', name: 'Plover', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-079.jpg' },
    { code: 'M-060', name: 'Butterflies', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-080.jpg' },
    { code: 'M-061', name: 'Lion Couple', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-081.jpg' },
    { code: 'M-062', name: 'Botan Kiku', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-082.jpg' },
    { code: 'M-066', name: 'Paulownia & Phoenix', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-083.jpg' },
    { code: 'M-067', name: 'Bamboo', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-005.jpg' },
    { code: 'M-068', name: 'Flower Basket', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-006.jpg' },
    { code: 'M-070', name: 'Old Coins', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-007.jpg' },
    { code: 'M-073', name: 'Kakotsuruhe', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-008.jpg' },
    { code: 'M-074', name: 'Flower Raft', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-009.jpg' },
    { code: 'M-075', name: 'Daffodil', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-015.jpg' },
    { code: 'M-076', name: 'Three Step Pine', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-016.jpg' },
    { code: 'M-077', name: 'Tiger & Cub', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-017.jpg' },
    { code: 'M-078', name: 'Mino Kiku', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-018.jpg' },
    { code: 'M-079', name: 'Bamboo & Sparrow', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-019.jpg' },
    { code: 'M-081', name: 'Crab', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-025.jpg' },
    { code: 'M-083', name: 'Wave & Maple', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-026.jpg' },
    { code: 'M-084', name: 'Katsujin Ken', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-027.jpg' },
    { code: 'M-085', name: 'Camellia', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-028.jpg' },
    { code: 'M-086', name: 'Peony & Lion', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-029.jpg' },
    { code: 'M-087', name: 'Sanscrit', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-035.jpg' },
    { code: 'M-088', name: 'Plum Branch', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-036.jpg' },
    { code: 'M-090', name: 'Mukade', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-037.jpg' },
    { code: 'M-092', name: 'Squirrel & Grapes', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-038.jpg' },
    { code: 'M-093', name: 'Crescent Moon', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-039.jpg' },
    { code: 'M-094', name: 'Falcon & Pine', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-045.jpg' },
    { code: 'M-097', name: 'Aizen Myo-o', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-046.jpg' },
    { code: 'M-098', name: 'Twisted Mino Dragon', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-047.jpg' },
    { code: 'M-099', name: 'Fudo Myo-o', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-048.jpg' },
    { code: 'M-100', name: 'Bishamonten', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-049.jpg' },
    { code: 'M-101', name: 'Rabbit', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-055.jpg' },
    { code: 'M-102', name: 'River Crab', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-056.jpg' },
    { code: 'M-104', name: 'Peony', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-057.jpg' },
    { code: 'M-105', name: 'Kyo Phoenix', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-058.jpg' },
    { code: 'M-106', name: 'Old Bones (Large)', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-059.jpg' },
    { code: 'M-108', name: 'Three Monkeys', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-065.jpg' },
    { code: 'M-109', name: 'Sparrow in Bamboo', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-066.jpg' },
    { code: 'M-110', name: 'Watanabe Tsuba', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-067.jpg' },
    { code: 'M-111', name: 'Cloud Dragon', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-068.jpg' },
    { code: 'M-112', name: 'Maple Leaves', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-069.jpg' },
    { code: 'M-113', name: 'Bamboo & Tiger', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-075.jpg' },
    { code: 'M-116', name: 'Kasen Sword Bean', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-076.jpg' },
    { code: 'M-117', name: 'Aun Lion', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-077.jpg' },
    { code: 'M-118', name: 'Dancing Tigers', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-menuki-078.jpg' }
  ];

  // SAYA gallery — all images, browse & type your code
  var SAYA_DESIGNS = [
    { code: 'S-1-001', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-000.jpg' },
    { code: 'S-1-002', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-001.jpg' },
    { code: 'S-1-003', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-002.jpg' },
    { code: 'S-1-004', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-003.jpg' },
    { code: 'S-1-005', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-004.jpg' },
    { code: 'S-1-006', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-005.jpg' },
    { code: 'S-1-007', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-006.jpg' },
    { code: 'S-1-008', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-007.jpg' },
    { code: 'S-1-009', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-008.jpg' },
    { code: 'S-1-010', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-009.jpg' },
    { code: 'S-1-011', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-010.jpg' },
    { code: 'S-1-012', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-011.jpg' },
    { code: 'S-1-013', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-012.jpg' },
    { code: 'S-1-014', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-013.jpg' },
    { code: 'S-1-015', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-014.jpg' },
    { code: 'S-1-016', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-015.jpg' },
    { code: 'S-1-017', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-016.jpg' },
    { code: 'S-1-018', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-017.jpg' },
    { code: 'S-1-019', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-018.jpg' },
    { code: 'S-1-020', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-019.jpg' },
    { code: 'S-1-021', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-020.jpg' },
    { code: 'S-1-022', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-021.jpg' },
    { code: 'S-1-023', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-022.jpg' },
    { code: 'S-1-024', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-023.jpg' },
    { code: 'S-1-025', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-024.jpg' },
    { code: 'S-1-026', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-025.jpg' },
    { code: 'S-1-027', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-026.jpg' },
    { code: 'S-1-028', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-027.jpg' },
    { code: 'S-1-029', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-028.jpg' },
    { code: 'S-1-030', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-029.jpg' },
    { code: 'S-1-031', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-030.jpg' },
    { code: 'S-1-032', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-031.jpg' },
    { code: 'S-1-033', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-032.jpg' },
    { code: 'S-1-034', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-033.jpg' },
    { code: 'S-1-035', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-034.jpg' },
    { code: 'S-1-036', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-035.jpg' },
    { code: 'S-1-037', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-036.jpg' },
    { code: 'S-1-038', name: '', img: 'https://cdn.shopify.com/s/files/1/0753/4080/8516/files/koshirae-saya-037.jpg' }
  ];

  /* ─────────────────────────────────────────────
     PRICE TABLE
  ───────────────────────────────────────────── */
  var PRICES = {
    'properties[Polishing Grade]': {
      standard: 670,
      deluxe:   1340,
      premium:  2680
    },
    'properties[Custom Signature Inscription]': {
      yes: 67
    },
    'properties[Habaki]': {
      'h-cu-yujo': 70,
      'h-cu-shonai': 70,
      'h-cu-kashu': 70,
      'h-ag-kamon': 150,
      'h-ag-owari': 150,
      'h-ag-yujo': 150,
      'h-ag-shonai': 150,
      'h-ag-wave': 150,
      'h-g1-sayagata': 150,
      'h-ki-sayagata': 350,
      'h-ki-yujo': 350,
      'h-ki-shonai': 350,
      'h-ki-double': 350,
      'h-ki-bi-sayagata': 350,
      'h-uegai': 350
    },
    'properties[Koshirae Type]': {
      shirasaya:   400,
      uchigatana:  1300
    },
    'properties[Tsuba Material]': {
      iron:   55,
      brass:  55
    },
    'properties[Fuchi-Kashira Material]': {
      silver: 120
    },
    'properties[Menuki Material]': {
      brass:  40,
      silver: 60
    },
    'properties[Tsukaito Material]': {
      cotton:  50,
      silk:    87,
      'cow-leather': 87,
      'pig-leather': 87,
      'deer-leather': 87
    },
    'properties[Tsukasame Style]': {
      'strips-knot':   54,
      'fully-wrapped': 188
    },
    'properties[Tsukasame Color]': {
      'antique-white': 14,
      togidashi:       54
    },
    'properties[Saya Lacquer]': {
      'kuro-ro':         320,
      'kuro-ishime':     320,
      'cha-ishime':      320,
      'kon-ishime':      320,
      'midori-ishime':   320,
      'hon-kuro-ishime': 357,
      'anshu-ishime':    357,
      'cha-urumi':       357,
      wakasa:            357,
      inden:             357,
      'kon-ro':          357,
      'cha-ro':          357,
      'shu-ro':          357,
      'shiro-ro':        357,
      'suke-nuri':       385,
      hirumaki:          385,
      'aka-tsuishu':     420,
      'kon-tsuishu':     420,
      kanshitsu:         440,
      'han-samemaki':    440,
      'so-zame':         1070
    },
    'properties[Koiguchi Type]': {
      'buffalo-horn': 54,
      brass:          67,
      silver:         100
    },
    'properties[Kurigata Type]': {
      'buffalo-horn': 67
    },
    'properties[Shitodome Type]': {
      silver: 14
    },
    'properties[Kojiri Type]': {
      'buffalo-horn':    67,
      'brass-round':     80,
      'iron-round':      80,
      'brass-decorated': 120,
      silver:            160
    },
    'properties[Sageo Material]': {
      silk: 40
    }
  };

  // Labels for breakdown display
  var PRICE_LABELS = {
    'properties[Polishing Grade]':           'Polishing Grade',
    'properties[Custom Signature Inscription]': 'Custom Inscription',
    'properties[Habaki]':                    'Habaki',
    'properties[Koshirae Type]':             'Koshirae',
    'properties[Tsuba Material]':            'Tsuba Material',
    'properties[Fuchi-Kashira Material]':    'Fuchi-Kashira',
    'properties[Menuki Material]':           'Menuki Material',
    'properties[Tsukaito Material]':         'Tsukaito',
    'properties[Tsukasame Style]':           'Tsukasame Style',
    'properties[Tsukasame Color]':           'Tsukasame Color',
    'properties[Saya Lacquer]':              'Saya Lacquer',
    'properties[Koiguchi Type]':             'Koiguchi',
    'properties[Kurigata Type]':             'Kurigata',
    'properties[Shitodome Type]':            'Shitodome',
    'properties[Kojiri Type]':               'Kojiri',
    'properties[Sageo Material]':            'Sageo'
  };

  // Props only visible when Uchigatana is selected
  var UCHI_ONLY_PROPS = [
    'properties[Tsuba Material]',
    'properties[Fuchi-Kashira Material]',
    'properties[Menuki Material]',
    'properties[Tsukaito Material]',
    'properties[Tsukasame Style]',
    'properties[Tsukasame Color]',
    'properties[Saya Lacquer]',
    'properties[Koiguchi Type]',
    'properties[Kurigata Type]',
    'properties[Shitodome Type]',
    'properties[Kojiri Type]',
    'properties[Sageo Material]'
  ];

  /* ─────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────── */
  function init() {
    var container = document.getElementById('kc-configurator');
    if (!container) return;

    // Read variant ID from data attribute if available
    var vid = container.getAttribute('data-variant-id');
    if (vid) VARIANT_ID = parseInt(vid, 10);

    setupAccordions();
    setupRadios();
    setupSelects();
    setupBreakdownToggle();
    setupAddToCart();
    initImageGrids();
    setupHabakiGrid();
    syncRadioVisuals();
    updateHabakiSelection();
    updatePricing();
  }

  /* ─────────────────────────────────────────────
     ACCORDIONS
  ───────────────────────────────────────────── */
  function setupAccordions() {
    document.querySelectorAll('.kc-section-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var section = btn.closest('.kc-section');
        var isOpen = section.classList.contains('open');
        section.classList.toggle('open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  /* ─────────────────────────────────────────────
     RADIO GROUPS
  ───────────────────────────────────────────── */
  function syncRadioVisuals(name) {
    document.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      if (name && radio.name !== name) return;
      var wrap = radio.closest('.kc-radio-opt, .kc-groove-opt, .kc-card-opt, .habaki-grid-item');
      if (wrap) { wrap.classList.toggle('is-selected', radio.checked); wrap.classList.toggle('selected', radio.checked); }
    });
  }

  function setupRadios() {
    document.addEventListener('click', function (e) {
      var opt = e.target.closest('.kc-radio-opt, .kc-groove-opt, .kc-card-opt, .habaki-grid-item');
      if (!opt) return;
      var input = opt.querySelector('input[type="radio"]');
      if (!input) return;
      input.checked = true;
      syncRadioVisuals(input.name);
      onRadioChange(input.name, input.value);
    });

    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.type !== 'radio') return;
      syncRadioVisuals(input.name);
      onRadioChange(input.name, input.value);
    });
  }

  function setupHabakiGrid() {
    var search = document.getElementById('habaki-search');
    var grid = document.getElementById('habaki-grid');
    if (!grid) return;

    if (search) {
      search.addEventListener('input', function () {
        var q = search.value.toLowerCase().trim();
        grid.querySelectorAll('.habaki-grid-item').forEach(function (el) {
          var code = (el.getAttribute('data-code') || '').toLowerCase();
          var name = (el.getAttribute('data-name') || '').toLowerCase();
          el.style.display = (!q || code.indexOf(q) !== -1 || name.indexOf(q) !== -1) ? '' : 'none';
        });
      });
    }
  }

  function onRadioChange(name, value) {
    handleConditionals(name, value);
    if (name === 'properties[Tsukaito Material]') {
      renderColorSwatches('tsukaito-colors', TSUKAITO_COLORS[value] || [], 'tsukaito-color-val', 'tsukaito-color-hint');
    }
    if (name === 'properties[Sageo Material]') {
      renderColorSwatches('sageo-colors', SAGEO_COLORS[value] || [], 'sageo-color-val', 'sageo-color-hint');
    }
    if (name === 'properties[Habaki]') {
      updateHabakiSelection();
    }
    updatePricing();
  }

  /* ─────────────────────────────────────────────
     SELECTS
  ───────────────────────────────────────────── */
  function setupSelects() {
    document.querySelectorAll('.kc-select').forEach(function (sel) {
      sel.addEventListener('change', function () {
        if (sel.id === 'tsuka-length') {
          toggleCond('cond-tsuka-custom', sel.value === 'custom');
        }
        updatePricing();
      });
    });
  }

  /* ─────────────────────────────────────────────
     CONDITIONALS
  ───────────────────────────────────────────── */
  function handleConditionals(name, value) {
    var map = {
      'properties[Hamon]': function (v) {
        toggleCond('cond-hamon-custom', v === 'custom');
      },
      'properties[Custom Signature Inscription]': function (v) {
        toggleCond('cond-inscription', v === 'yes');
      },
      'properties[Koshirae Type]': function (v) {
        var el = document.getElementById('kc-uchi-opts');
        if (el) el.classList.toggle('is-visible', v === 'uchigatana');
      },
      'properties[Koiguchi Reinforcement]': function (v) {
        toggleCond('cond-koiguchi', v === 'yes');
      },
      'properties[Kurigata Reinforcement]': function (v) {
        toggleCond('cond-kurigata', v === 'yes');
      },
      'properties[Shitodome]': function (v) {
        toggleCond('cond-shitodome', v === 'yes');
      },
      'properties[Kojiri]': function (v) {
        toggleCond('cond-kojiri', v === 'yes');
      }
    };

    if (map[name]) map[name](value);
  }

  function toggleCond(id, show) {
    var el = document.getElementById(id);
    if (el) el.classList.toggle('is-visible', show);
  }

  function updateHabakiSelection() {
    var input = document.getElementById('habaki-selected-display');
    var preview = document.getElementById('habaki-preview');
    var checked = document.querySelector('input[name="properties[Habaki]"]:checked');
    if (!input) return;
    if (!checked) {
      input.value = '';
      if (preview) preview.innerHTML = '';
      return;
    }
    var item = checked.closest('.habaki-grid-item');
    var code = item ? (item.getAttribute('data-code') || '') : '';
    var name = item ? (item.getAttribute('data-name') || '') : '';
    var img = item ? item.querySelector('img') : null;
    input.value = code ? (code + (name ? ' ' + name : '')) : (VALUE_LABELS[checked.value] || checked.value);
    if (preview && img) {
      var label = code + (name ? ' — ' + name : '');
      preview.innerHTML = '<img src="' + img.currentSrc + '" alt="' + escHtml(label) + '"><div class="preview-label">' + escHtml(label) + '</div>';
    }
  }

  /* ─────────────────────────────────────────────
     COLOR SWATCHES
  ───────────────────────────────────────────── */
  function renderColorSwatches(containerId, colors, hiddenInputId, hintId) {
    var container = document.getElementById(containerId);
    var hidden    = document.getElementById(hiddenInputId);
    var hint      = document.getElementById(hintId);
    if (!container) return;

    container.innerHTML = '';
    if (hint) hint.style.display = colors.length ? 'none' : '';

    colors.forEach(function (c) {
      var swatch = document.createElement('div');
      swatch.className = 'kc-swatch';
      swatch.style.backgroundColor = c.hex;
      if (c.light) swatch.style.boxShadow = 'inset 0 0 0 1.5px #ccc';
      swatch.setAttribute('data-name', c.name);
      swatch.setAttribute('title', c.name);

      swatch.addEventListener('click', function () {
        container.querySelectorAll('.kc-swatch').forEach(function (s) {
          s.classList.remove('is-selected');
        });
        swatch.classList.add('is-selected');
        if (hidden) hidden.value = c.name;
        updatePricing();
      });

      container.appendChild(swatch);
    });

    // Reset hidden value when colors change
    if (hidden) hidden.value = '';
  }

  /* ─────────────────────────────────────────────
     IMAGE GRIDS
  ───────────────────────────────────────────── */
  function initImageGrids() {
    renderImageGrid('tsuba-grid', TSUBA_DESIGNS, {
      inputId:    'tsuba-design',
      previewId:  'tsuba-preview',
      searchId:   'tsuba-search',
      hasNames:   true
    });
    renderImageGrid('fuchi-grid', FUCHI_DESIGNS, {
      inputId:    'fuchi-design',
      previewId:  'fuchi-preview',
      searchId:   'fuchi-search',
      hasNames:   true
    });
    renderImageGrid('menuki-grid', MENUKI_DESIGNS, {
      inputId:    'menuki-design',
      previewId:  'menuki-preview',
      searchId:   'menuki-search',
      hasNames:   true
    });
    renderImageGrid('saya-grid', SAYA_DESIGNS, {
      inputId:    'saya-design',
      previewId:  'saya-preview',
      searchId:   'saya-search',
      hasNames:   false
    });
  }

  function renderImageGrid(gridId, items, opts) {
    var grid = document.getElementById(gridId);
    if (!grid) return;

    grid.innerHTML = '';

    items.forEach(function (item) {
      var div = document.createElement('div');
      div.className = 'grid-item';
      div.setAttribute('data-code', item.code);
      div.setAttribute('data-name', item.name || '');

      var label = item.code + (item.name ? ' ' + item.name : '');
      div.innerHTML =
        '<img src="' + item.img + '" alt="' + escHtml(label) + '" loading="lazy" width="110" height="110">' +
        '<span class="grid-label">' + escHtml(item.code) + (item.name ? '<small>' + escHtml(item.name) + '</small>' : '') + '</span>' +
        '<span class="grid-check">✓</span>';

      div.addEventListener('click', function () {
        selectGridItem(grid, div, item, opts);
      });

      grid.appendChild(div);
    });

    // Search filter
    var search = document.getElementById(opts.searchId);
    if (search) {
      search.addEventListener('input', function () {
        var q = search.value.toLowerCase().trim();
        grid.querySelectorAll('.grid-item').forEach(function (el) {
          var code = (el.getAttribute('data-code') || '').toLowerCase();
          var name = (el.getAttribute('data-name') || '').toLowerCase();
          el.style.display = (!q || code.indexOf(q) !== -1 || name.indexOf(q) !== -1) ? '' : 'none';
        });
      });
    }

    // Allow manual input to sync back to grid highlight
    var input = document.getElementById(opts.inputId);
    if (input) {
      input.addEventListener('input', function () {
        var val = input.value.trim().toLowerCase();
        grid.querySelectorAll('.grid-item').forEach(function (el) {
          var code = (el.getAttribute('data-code') || '').toLowerCase();
          var name = (el.getAttribute('data-name') || '').toLowerCase();
          var matches = val && (code === val || (code + ' ' + name) === val || code.indexOf(val) === 0);
          el.classList.toggle('selected', !!matches);
        });
      });
    }
  }

  function selectGridItem(grid, el, item, opts) {
    // Deselect all in this grid
    grid.querySelectorAll('.grid-item').forEach(function (o) {
      o.classList.remove('selected');
    });
    el.classList.add('selected');

    // Update preview
    var preview = document.getElementById(opts.previewId);
    if (preview) {
      var label = item.code + (item.name ? ' \u2014 ' + item.name : '');
      preview.innerHTML =
        '<img src="' + item.img + '" alt="' + escHtml(label) + '">' +
        '<div class="preview-label">' + escHtml(label) + '</div>';
      preview.style.display = '';
    }

    // Update text input (for Tsuba: code + name; for galleries: code as image reference)
    var input = document.getElementById(opts.inputId);
    if (input) {
      if (opts.hasNames && item.name) {
        input.value = item.code + ' ' + item.name;
      } else {
        // For gallery-only: just pre-fill with image ref so staff can locate it;
        // customer can overwrite with their real catalog code
        input.value = item.code;
      }
      // Scroll input into view
      el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function escHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ─────────────────────────────────────────────
     PRICING
  ───────────────────────────────────────────── */
  function getRadioVal(name) {
    var el = document.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : null;
  }

  function updatePricing() {
    var total     = BASE_PRICE;
    var breakdown = [{ label: 'Base Shinken', price: BASE_PRICE, base: true }];
    var isUchi    = getRadioVal('properties[Koshirae Type]') === 'uchigatana';

    Object.keys(PRICES).forEach(function (prop) {
      // Skip uchigatana-only props if shirasaya is selected
      if (!isUchi && UCHI_ONLY_PROPS.indexOf(prop) !== -1) return;
      // Skip sub-option props if their parent "no/yes" is "no"
      if (prop === 'properties[Koiguchi Type]'  && getRadioVal('properties[Koiguchi Reinforcement]')  !== 'yes') return;
      if (prop === 'properties[Kurigata Type]'  && getRadioVal('properties[Kurigata Reinforcement]')  !== 'yes') return;
      if (prop === 'properties[Shitodome Type]' && getRadioVal('properties[Shitodome]') !== 'yes') return;
      if (prop === 'properties[Kojiri Type]'    && getRadioVal('properties[Kojiri]')    !== 'yes') return;

      var val = getRadioVal(prop);
      if (!val) return;
      var priceMap = PRICES[prop];
      var p = priceMap[val];
      if (p && p > 0) {
        total += p;
        breakdown.push({ label: PRICE_LABELS[prop] || prop, price: p });
      }
    });

    // Update total displays
    var fmt = '$' + total.toLocaleString('en-US');
    var summaryTotal = document.getElementById('kc-summary-total');
    var headerTotal  = document.getElementById('kc-total');
    var atcPrice     = document.getElementById('kc-atc-price');
    if (summaryTotal) summaryTotal.textContent = fmt;
    if (headerTotal)  headerTotal.textContent  = fmt;
    if (atcPrice)     atcPrice.textContent      = fmt;

    renderBreakdown(breakdown);
  }

  function renderBreakdown(items) {
    var container = document.getElementById('kc-summary-breakdown');
    if (!container) return;
    container.innerHTML = '';
    items.forEach(function (item) {
      var div = document.createElement('div');
      div.className = 'kc-bd-item' + (item.base ? ' is-base' : '');
      div.innerHTML =
        '<span>' + item.label + '</span>' +
        '<span class="kc-bd-price">+$' + item.price.toLocaleString('en-US') + '</span>';
      if (item.base) div.querySelector('.kc-bd-price').textContent = '$' + item.price.toLocaleString('en-US');
      container.appendChild(div);
    });
  }

  /* ─────────────────────────────────────────────
     BREAKDOWN TOGGLE
  ───────────────────────────────────────────── */
  function setupBreakdownToggle() {
    var btn = document.getElementById('kc-breakdown-toggle');
    var bd  = document.getElementById('kc-summary-breakdown');
    if (!btn || !bd) return;
    btn.addEventListener('click', function () {
      var open = bd.classList.toggle('is-open');
      btn.textContent = (open ? '▴ Hide' : '▾ Show') + ' price breakdown';
    });
  }

  /* ─────────────────────────────────────────────
     VALIDATION
  ───────────────────────────────────────────── */
  var REQUIRED_RADIO_FIELDS = [
    { prop: 'properties[Hamon]',                         fieldId: 'field-hamon' },
    { prop: 'properties[Hi Groove]',                     fieldId: 'field-hi-groove' },
    { prop: 'properties[Polishing Grade]',               fieldId: 'field-polishing' },
    { prop: 'properties[Custom Signature Inscription]',  fieldId: 'field-inscription' },
    { prop: 'properties[Habaki]',                        fieldId: 'field-habaki' }
  ];

  function validateForm() {
    var valid = true;

    // Blade length
    var bladeField = document.getElementById('field-blade-length');
    var bladeInput = document.getElementById('blade-length');
    if (bladeInput && !bladeInput.value.trim()) {
      if (bladeField) bladeField.classList.add('has-error');
      valid = false;
    } else {
      if (bladeField) bladeField.classList.remove('has-error');
    }

    // Required radios
    REQUIRED_RADIO_FIELDS.forEach(function (rf) {
      var fieldEl = document.getElementById(rf.fieldId);
      if (!fieldEl) return;
      var val = getRadioVal(rf.prop);
      if (!val) {
        fieldEl.classList.add('has-error');
        valid = false;
      } else {
        fieldEl.classList.remove('has-error');
      }
    });

    if (!valid) {
      // Open blade section and scroll to first error
      var bladeSection = document.querySelector('[data-section="blade"]');
      if (bladeSection) bladeSection.classList.add('open');
      var firstError = document.querySelector('.has-error');
      if (firstError) {
        setTimeout(function () {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      }
    }
    return valid;
  }

  /* ─────────────────────────────────────────────
     COLLECT PROPERTIES
  ───────────────────────────────────────────── */
  function collectProperties() {
    var props = {};
    var isUchi = getRadioVal('properties[Koshirae Type]') === 'uchigatana';

    // Text inputs & textareas
    document.querySelectorAll('.kc-input, .kc-select').forEach(function (el) {
      if (!el.name || !el.name.startsWith('properties[')) return;
      var val = (el.value || '').trim();
      if (!val) return;
      // Skip values inside hidden conditionals
      var cond = el.closest('.kc-cond');
      if (cond && !cond.classList.contains('is-visible')) return;
      // Skip uchigatana-only fields when shirasaya is selected
      var uchiParent = el.closest('#kc-uchi-opts');
      if (uchiParent && !isUchi) return;
      var key = el.name.replace('properties[', '').replace(']', '');
      props[key] = val;
    });

    // Radio inputs
    document.querySelectorAll('input[type="radio"]:checked').forEach(function (el) {
      if (!el.name || !el.name.startsWith('properties[')) return;
      var uchiParent = el.closest('#kc-uchi-opts');
      if (uchiParent && !isUchi) return;
      var key = el.name.replace('properties[', '').replace(']', '');
      // Map internal values to human-readable labels for cart
      props[key] = humanizeValue(el.name, el.value);
    });

    // Color swatches via hidden inputs
    var tsukaito = document.getElementById('tsukaito-color-val');
    if (tsukaito && tsukaito.value) props['Tsukaito Color'] = tsukaito.value;
    var sageo = document.getElementById('sageo-color-val');
    if (sageo && sageo.value) props['Sageo Color'] = sageo.value;

    return props;
  }

  // Convert internal radio values to readable strings for line item properties
  var VALUE_LABELS = {
    'swordsmith-choice': 'Leave to swordsmith',
    'bo-hi':             'Bo-Hi',
    'soe-hi':            'Soe-Hi',
    'koshi-hi':          'Koshi-Hi',
    'naginata-hi':       'Naginata-Hi',
    'none':              'None',
    'standard':          'Standard',
    'deluxe':            'Deluxe',
    'premium':           'Premium',
    'copper-plain':      'Copper Plain',
    'copper-yujo':       'Copper Yujo',
    'silver-yujo':       'Silver Yujo',
    'silver-shonai':     'Silver Shonai-Migaki',
    'gold-single':       'Gold Single-Piece',
    shirasaya:           'Shirasaya (+$400)',
    uchigatana:          'Uchigatana (+$1,300)',
    stainless:           'Stainless Steel',
    iron:                'Iron (Tetsu)',
    brass:               'Brass',
    copper:              'Copper',
    silver:              'Silver',
    alloy:               'Alloy',
    cotton:              'Cotton',
    silk:                'Silk',
    leather:             'Leather',
    suede:               'Suede',
    'hineri-maki':       'Hineri-maki',
    'ikkan-maki':        'Ikkan-maki',
    'gangi-maki':        'Gangi-maki',
    'strips-no-knot':    'Strips Without Navel Knot',
    'strips-knot':       'Strips With Navel Knot',
    'fully-wrapped':     'Fully Wrapped With Navel Knot',
    white:               'White',
    black:               'Black',
    anshu:               'Anshu Crimson',
    'antique-white':     'Antique White',
    togidashi:           'Togidashi Sanded',
    yagyu:               'Yagyu Style',
    central:             'Central',
    'kuro-ro':           'Kuro-ro (Black Gloss)',
    'kuro-ishime':       'Kuro-ishime',
    'cha-ishime':        'Cha-ishime',
    'kon-ishime':        'Kon-ishime',
    'midori-ishime':     'Midori-ishime',
    'hon-kuro-ishime':   'Hon Kuro-ishime',
    'anshu-ishime':      'Anshu-ishime',
    'cha-urumi':         'Cha-urumi',
    wakasa:              'Wakasa',
    inden:               'Inden',
    'kon-ro':            'Kon-ro',
    'cha-ro':            'Cha-ro',
    'shu-ro':            'Shu-ro',
    'shiro-ro':          'Shiro-ro',
    'suke-nuri':         'Suke-nuri',
    hirumaki:            'Hirumaki',
    'aka-tsuishu':       'Aka-tsuishu',
    'kon-tsuishu':       'Kon-tsuishu',
    kanshitsu:           'Kanshitsu',
    'han-samemaki':      'Han-samemaki',
    'so-zame':           'So-zame (Full Ray Skin)',
    'buffalo-horn':      'Buffalo Horn',
    'brass-round':       'Brass Round',
    'iron-round':        'Iron Round',
    'brass-decorated':   'Brass Decorated',
    no:                  'No',
    yes:                 'Yes',
    custom:              'Custom (see request)'
  };

  function humanizeValue(prop, val) {
    return VALUE_LABELS[val] || val;
  }

  /* ─────────────────────────────────────────────
     ADD TO CART
  ───────────────────────────────────────────── */
  function setupAddToCart() {
    var btn = document.getElementById('kc-atc-btn');
    if (!btn) return;

    btn.addEventListener('click', function () {
      if (!validateForm()) return;

      var props = collectProperties();
      btn.disabled = true;
      btn.innerHTML = '<span class="kc-spinner"></span>Adding to cart\u2026';

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({
          id:         VARIANT_ID,
          quantity:   1,
          properties: props
        })
      })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw new Error(e.description || 'Cart error'); });
        return res.json();
      })
      .then(function () {
        // Redirect to cart
        window.location.href = '/cart';
      })
      .catch(function (err) {
        btn.disabled = false;
        var atcPrice = document.getElementById('kc-atc-price');
        btn.innerHTML = 'Add to Cart \u2014 <span id="kc-atc-price">' + (atcPrice ? atcPrice.textContent : '$5,000') + '</span>';
        alert('Could not add to cart: ' + err.message + '\nPlease try again.');
      });
    });
  }

  /* ─────────────────────────────────────────────
     BOOT
  ───────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
